export default class CustomRouteData {
    constructor(id, theyrId, routePoints, description, creationDate, verified) {
        this.id = id
        this.theyrId = theyrId
        this.routePoints = routePoints
        this.description = description
        this.creationDate = creationDate
        this.verified = verified
    }
}

